module.exports = "<a ng-disabled=!date class=\"btn btn-default btn-xs\" ng-href={{url}}><span class=\"glyphicon glyphicon-remove-circle\" aria-hidden=true></span>&nbsp; <span class=\"hidden-xs ng-scope\" translate=DOWNLOAD>Download</span></a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/rightsDownloadReport.html
// module id = 436
// module chunks = 0